import axios, { AxiosPromise } from "axios";
import {
  DateQuery,
  Paginated,
  PaginationQuery,
  convertToUrlParams,
} from "./common";

export type CommentUpdate = {
  content: string;
};

export type CommentCreate = {
  twinUuid: string;
  content: string;
  format?: string;
};
export type Comment = CommentCreate & {
  uuid: string;
  modified: string;
  created: string;
  originalAuthor: string;
  author: string;
};

export type CommentQuery = PaginationQuery & {
  twin?: string;
  author?: string;
  createdby?: string;
  created?: DateQuery;
  modified?: DateQuery;
};

export function postComment(comment: CommentCreate): AxiosPromise<Comment> {
  return axios.post(`/api/comments`, comment);
}

export function getComments(
  query: CommentQuery,
): AxiosPromise<Paginated<Comment[]>> {
  const q = convertToUrlParams(query);
  return axios.get(`/api/comments?${q}`);
}

export function putComment(comment: CommentUpdate): AxiosPromise<Comment> {
  return axios.put(`/api/comments`, comment);
}

export function getCommentHistory(
  commentId: string,
  query?: CommentQuery,
): AxiosPromise<Paginated<Comment[]>> {
  const q = convertToUrlParams(query);
  return axios.get(`/api/comments/history/${commentId}?${q}`);
}
